import { Mail, MessageCircle } from "lucide-react";
import ContactFormBrandMark from "@/components/contact/ContactFormBrandMark";
import { useCms } from "@/lib/cms";
import { resolveContactCopy } from "@/lib/siteContent";

export default function ContactInquiryAside({ compact = false, modal = false }) {
  const { cms } = useCms();
  const copy = resolveContactCopy(cms);
  const email = cms?.company_email || "dsitesolution@dsitesolution.com";
  const kakaoUrl = cms?.kakao_channel_url || "https://pf.kakao.com/_rmpFn/chat";
  const isModal = compact && modal;

  return (
    <div
      className={`flex w-full flex-col ${
        isModal ? "h-full min-h-0" : compact ? "" : "flex-1"
      }${compact ? " lg:pr-2" : ""}`}
    >
      <div className={`flex items-center gap-2 ${isModal ? "mb-3" : "mb-6"}`}>
        <div className="w-6 h-px bg-white/30" />
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-white/40">
          {copy.eyebrow}
        </span>
      </div>
      <h2
        className={`font-display font-medium tracking-tight text-white leading-[1.1] ${
          isModal
            ? "text-xl sm:text-2xl"
            : compact
              ? "text-2xl sm:text-3xl"
              : "text-3xl sm:text-4xl lg:text-5xl"
        }`}
      >
        {copy.line1}
        <br />
        <span className="text-white/50">{copy.line2}</span>
      </h2>
      <p
        className={`text-white/60 leading-relaxed ${
          isModal
            ? "mt-2 max-w-sm text-sm"
            : compact
              ? "mt-4 max-w-sm text-sm"
              : "mt-6 max-w-md text-sm"
        }`}
      >
        {copy.description}
      </p>

      <div
        className={`shrink-0 ${
          isModal ? "mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-2" : "space-y-4"
        } ${compact && !isModal ? "mt-8" : ""} ${!compact ? "mt-10" : isModal ? "" : "mt-8"}`}
      >
        <a
          href={`mailto:${email}`}
          data-testid="contact-email-link"
          className={`flex items-center gap-3 border border-white/10 rounded-xl hover:border-white/25 transition-colors group ${
            isModal ? "p-3" : "gap-4 rounded-2xl p-5"
          }`}
        >
          <div
            className={`rounded-lg bg-white/5 border border-white/10 flex items-center justify-center group-hover:bg-white group-hover:text-black transition-colors ${
              isModal ? "w-8 h-8 shrink-0" : "w-10 h-10"
            }`}
          >
            <Mail size={isModal ? 14 : 16} />
          </div>
          <div className="min-w-0">
            <div className="text-[10px] uppercase tracking-[0.2em] text-white/40">이메일</div>
            <div className={`text-white truncate ${isModal ? "text-xs" : "text-sm"}`}>
              {email}
            </div>
          </div>
        </a>
        <a
          href={kakaoUrl}
          target="_blank"
          rel="noreferrer"
          data-testid="contact-kakao-link"
          className={`flex items-center gap-3 border border-white/10 rounded-xl hover:border-white/25 transition-colors group ${
            isModal ? "p-3" : "gap-4 rounded-2xl p-5"
          }`}
        >
          <div
            className={`rounded-lg bg-[#FEE500] flex items-center justify-center text-black shrink-0 ${
              isModal ? "w-8 h-8" : "w-10 h-10"
            }`}
          >
            <MessageCircle size={isModal ? 14 : 16} />
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-white/40">카카오톡 채널</div>
            <div className={`text-white ${isModal ? "text-xs" : "text-sm"}`}>즉시 상담하기</div>
          </div>
        </a>
      </div>

      {isModal ? <ContactFormBrandMark variant="modal-aside" /> : null}
    </div>
  );
}
